<template>
  <div class="p-6 bg-shtax-800 min-h-screen flex justify-center items-center">
    <div class="w-full max-w-md">
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <shtax-logo />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Adres e-mail" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Hasło" type="password" />
          
          <shtax-checkbox class="mt-6 w-full" v-model:checked="form.remember" label="Zapamiętaj mnie" />
        </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-100 flex">
          <loading-button :loading="form.processing" class="ml-auto btn-shtax" type="submit">Zaloguj się</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxLogo from '@/ShtaxComponents/Logo'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'

export default {
  metaInfo: { title: 'Login' },
  components: {
    LoadingButton,
    TextInput,
    ShtaxLogo,
    ShtaxCheckbox
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post(this.route('login.store'))
    },
  },
}
</script>
